export default __webpack_public_path__ + "static/media/mini_balls_loader.9e61fcde.svg";